import { defineSlotRecipe } from "@chakra-ui/react";

const radioCardSlotRecipe = defineSlotRecipe({
  className: "chakra-radio-group",
  slots: ["root", "item", "label", "itemControl", "itemText"],
  base: {
    root: {
      width: "full"
    },
    label: {
      textStyle: "title.3"
    },
    item: {
      bg: "canvas.dim",
      border: "sm",
      borderRadius: "lg",
      borderColor: "canvas.dim",
      boxShadow: "none",
      shadow: "none",
      _disabled: {
        cursor: "not-allowed",
        filter: "grayscale(100%)"
      },
      _hover: {
        cursor: "pointer",
        borderColor: "button.bg.filledHover"
      },
      _checked: {
        borderColor: "text",
        boxShadow: "none",
        shadow: "none"
      }
    },
    itemControl: {
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center"
    },
    itemText: {
      textAlign: "center",
      textStyle: "folio.standard",
      color: "text.action",
      _checked: {
        fontWeight: "semibold",
        color: "text"
      }
    }
  }
});

export default radioCardSlotRecipe;
